import { useState, useEffect } from "react";

import { FetchService } from "../../API/FetchService.js";
import { FetchComponent } from "../FetchComponent/FetchComponent.jsx";
import { SwitchAnimation } from "../Animation/Animation.jsx";

import { CabinetMainContent } from "./CabinetMainContent/CabinetMainContent.jsx";
import { CabinetNavbar } from "./CabinetNavbar/CabinetNavbar.jsx";

import styles from "./Cabinet.module.css";

export const Cabinet = () => {
  const context = window.data;
  const { email } = context;
  const [responseData, setResponseData] = useState({
    data: [],
    loading: true,
    error: false,
  });
  const { data, loading, error } = responseData;
  const [activeUser, setActiveUser] = useState(0);

  useEffect(() => {
    new FetchService({ email })
      .getPersonList()
      .then(({ data }) => {
        setResponseData((prev) => {
          return { ...prev, data };
        });
      })
      .catch(() => {
        setResponseData((prev) => {
          return { ...prev, error: true };
        });
      })
      .finally(() => {
        setResponseData((prev) => {
          return { ...prev, loading: false };
        });
      });
  }, [email]);

  return (
    <FetchComponent
      keyAnimation={loading}
      loading={loading}
      error={error}
      heightContainer="100vh"
    >
      <div className="container-xl my-3">
        {data.length ? (
          <>
            <CabinetNavbar
              data={data}
              activeUser={activeUser}
              setActiveUser={setActiveUser}
            />
            <hr />
            <SwitchAnimation keyAnimation={activeUser}>
              <CabinetMainContent
                data={data}
                activeUser={activeUser}
                email={email}
              />
            </SwitchAnimation>
          </>
        ) : (
          <div className={styles.messageWrapper}>
            <h1>Уважаемый пользователь!</h1>
            <h2>
              Чтобы получить доступ к информации в личном кабинете, оставте у
              администратора тот адрес электронной почты, с которым вы
              зарегистрировались на сайте.
            </h2>
          </div>
        )}
      </div>
    </FetchComponent>
  );
};
